import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  connect() {
    // Setup drag and drop events
    this.element.addEventListener("dragover", this.handleDragOver.bind(this))
    this.element.addEventListener("drop", this.handleDrop.bind(this))
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("dragover", this.handleDragOver.bind(this))
    this.element.removeEventListener("drop", this.handleDrop.bind(this))
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    // Only trigger if clicking the dropzone area, not the input itself
    if (event.target !== this.inputTarget) {
      this.inputTarget.click()
    }
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add("border-blue-500")
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.remove("border-blue-500")

    const files = event.dataTransfer.files
    if (files.length > 0 && files[0].type.startsWith("image/")) {
      this.inputTarget.files = files
      this.showPreview(files[0])
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.showPreview(file)
    } else {
      this.resetPreview()
    }
  }

  showPreview(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.style.backgroundImage = `url('${e.target.result}')`
      this.previewTarget.classList.remove("hidden")
      this.placeholderTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }

  resetPreview() {
    this.previewTarget.style.backgroundImage = "none"
    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
  }
} 